import SectionHeading from "./SectionHeading";
import { persons } from "@/mocks/home";

export default function PersonIndex() {
  return (
    <section id="persons" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="04"
          eyebrow="Person Index"
          title="人物索引 · 按条目找全记录"
          desc="把零散收录按人物归拢，每个人物对应一个独立条目，条目内按时间从新到旧排列该人物的全部图集，方便一次看完整条线索。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {persons.map((person) => (
            <a
              key={person.handle}
              href="#latest"
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={person.avatar}
                  alt={`${person.name} 黑料照片人物合集`}
                  title={`${person.name} 黑料照片全收录`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="truncate font-heading text-base font-bold text-foreground-950">{person.name}</p>
                  <span className="shrink-0 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                    {person.tag}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-500">{person.handle}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1 font-semibold text-primary-700">
                    <i className="ri-stack-line text-sm"></i>
                    {person.count} 个合集
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-sm text-accent-600"></i>
                    热度 {person.heat}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-5 sm:flex-row">
          <p className="text-sm text-foreground-600">
            还有 <span className="font-heading font-bold text-primary-700">3,956</span> 位人物条目未在当前视图展示。
          </p>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
          >
            订阅更新提醒
            <i className="ri-notification-3-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}